export default __webpack_public_path__ + "static/media/happyclient3.65fbaf3e.svg";